import { useRef,useState } from 'react'

import Comp_TransactionType from '../../components/datacontrols/controlTransactiontype.jsx'
import ComponentTagSelector from '../../components/tags/ComponentTagSelector.jsx'
import './testpage.scss'
import Comp_PropertyType from '../../components/datacontrols/controlPropertytype.jsx';
import Comp_Colonies from '../../components/datacontrols/controlColony.jsx';
import Comp_GeneralFeatures from '../../components/datacontrols/controlGeneral.jsx';
import Comp_UserTypes from '../../components/datacontrols/controlUserType.jsx';
import Comp_ClientTypes from '../../components/datacontrols/controlClienttype.jsx';
import Comp_Cities from './../../components/datacontrols/controlCity';
import Comp_ProjectDeveloper from '../../components/datacontrols/controlProjectDeveloper.jsx';


function Testpage(){

  const tagrefTransType = useRef(null);
  const tagrefPropType = useRef(null);
  const tagrefColony=useRef(null);
  const tagrefFeature = useRef(null);
  const tagrefUser=useRef(null);
  const tagrefClient=useRef(null);

  const tagrefCity = useRef(null);
  const tagrefDeveloper = useRef(null);

  const [selectedCities,setSelectedCities] = useState([]);
  const [selectedDevelopers,setSelectedDevelopers] = useState([]);


  const handleSelectTransactionType = (tag) => {
    // alert('in the TestPage of handleTransactionTypeSelect event')
    console.log(tag);
  }

  const handleRemoveTransactionType = (tag) => {
    // alert('in the TestPage of handleRemoveTransactionType event')
    console.log(tag);
  }

  const handleChangeTransactionType = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }


  const handleSetTtypeTags = () =>{
    let tags = [{id:'1', transactiontype:"Purchase"},{id:'2', transactiontype:"Sale"}]
    tagrefTransType.current.setTransactionTypeTags(tags)
  }


  const handleGetTtypeTags = () =>{
    let tags = tagrefTransType.current.getTransactionTypeTags()
    console.log(tags)
  }






  const handleSelectPropertyType = (tag) => {
    console.log(tag);
  }

  const handleRemovePropertyType = (tag) => {
    console.log(tag);
  }

  const handleChangePropertyType = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }
  const handleSetPtypeTags = () =>{
    let tags = [{id:'1', propertytype:"House"},{id:'2', propertytype:"DDA Flat"}]
    tagrefPropType.current.setPropertyTypeTags(tags)
  }


  const handleGetPtypeTags = () =>{
    let tags = tagrefPropType.current.getPropertyTypeTags()
    console.log(tags)
  }




  const handleSelectColony = (tag) => {
    console.log(tag);
  }

  const handleRemoveColony = (tag) => {
    console.log(tag);
  }

  const handleChangeColony = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }

  const handleSetColonyTags = () =>{
    let tags = [{id:'1', name:"Green Park"},{id:'2', name:"Safdarjung Enclave"}]
    tagrefColony.current.setColonyTags(tags)
  }


  const handleGetColonyTags = () =>{
    let tags = tagrefColony.current.getColonyTags()
    console.log(tags)
  }

  






  const handleSelectFeature = (tag) => {
    console.log(tag);
  }

  const handleRemoveFeature = (tag) => {
    console.log(tag);
  }

  const handleChangeFeature = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }

  const handleSetFeatureTags = () =>{
    let tags = [{id:'1', tagname:"Corner"},{id:'2', tagname:"Park Facing"}]
    tagrefFeature.current.setFeatureTags(tags)
  }


  const handleGetFeatureTags = () =>{
    let tags = tagrefFeature.current.getFeatureTags()
    console.log(tags)
  }





  const handleSelectUserType = (tag) => {
    console.log(tag);
  }

  const handleRemoveUserType = (tag) => {
    console.log(tag);
  }

  const handleChangeUserType = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }




  const handleSetUserTags = () =>{
    let tags = [ {
      "id": 1,
      "usertype": "Owner"
  },
  {
      "id": 2,
      "usertype": "Builder"
  }]

    tagrefUser.current.setUserTypeTags(tags)
  }


  const handleGetUserTags = () =>{
    let tags = tagrefUser.current.getUserTypeTags()
    console.log(tags)
  }

  const   handlegetIDTags  = () =>{
    let tags = tagrefUser.current.getTagsbyIds([1,3])
    console.log(tags)
  }

  const handleselected = () =>{

    let tags = tagrefTransType.current.getTransactionTypeTags()
    console.log(tags)

  }








  const handleSelectClientType = (tag) => {
    console.log(tag);
  }

  const handleRemoveClientType = (tag) => {
    console.log(tag);
  }

  const handleChangeClientType = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }





  const handleSelectCity = (tag) => {
    console.log(tag);
  }

  const handleRemoveCity = (tag) => {
    console.log(tag);
  }

  const handleChangeCity = (tag) => {
    // alert('in the TestPage of handleChangeTransactionType event')
    console.log(tag);
  }









  const handleSetClientTags = () =>{
    let tags = [ {
      "id": 1,
      "clienttype": "Owner"
  },
  {
      "id": 2,
      "clienttype": "Builder"
  }]

    tagrefClient.current.setClientTypeTags(tags)
  }


  const handleGetClientTags = () =>{
    let tags = tagrefClient.current.getClientTypeTags()
    console.log(tags)
  }






  const handleSetCityTags = () =>{
    let tags = [ {
      "id": 1,
      "city": "New Delhi"
  },
  {
      "id": 2,
      "city": "Gurgaonss"
  }]

    tagrefCity.current.setCityTags(tags)
  }


  const handleGetCityTags = () =>{
    let tags = tagrefCity.current.getCityTags()
    console.log(tags)
  }









  return (
    <>
      <div className='testpage'>Testpage for Testing Componants
          <ComponentTagSelector 
              style={{ width: "500px" }}
              // placeHolder="Select Colonies"
              // displayKey={'transactiontype'}
              dataURL={"http://localhost:8800/api/masters/colonies"}
              // style={{ width: "400px" }}
              // maxTags={1} 
              >
          </ComponentTagSelector>

      </div>
      <div style={{width:'500px',display:'flex'}}>
              <h4>Transactiontypes</h4>
              <p></p>

    
    
            <div className="first" style={{flex:1}} >
              <Comp_TransactionType
                  ref={tagrefTransType}
                  // maxTags={1}
                  onTransactionTypeSelect={handleSelectTransactionType}
                  onTransactionTypeRemove={handleRemoveTransactionType}
                  onTransctionTypeChangeTag={handleChangeTransactionType}
                  >
              </Comp_TransactionType>

            </div>
            <div className="second" style={{flex:2}}>
              <button onClick={handleSetTtypeTags}>set Tags</button>
              <button onClick={handleGetTtypeTags}>get Tags</button>

              <button onClick={handleselected}>check</button>
            </div>

      </div>
      <div>
        <h4>Propertytypes</h4>
            <Comp_PropertyType
                ref={tagrefPropType}
                // maxTags={1}
                onPropertyTypeSelect={handleSelectPropertyType}
                onPropertyTypeRemove={handleRemovePropertyType}
                onPropertyTypeChangeTag={handleChangePropertyType}
            >

            </Comp_PropertyType>

            <button onClick={handleSetPtypeTags}>set Tags</button>
            <button onClick={handleGetPtypeTags}>get Tags</button>

      </div>


      <div>
        <h4>Colonies</h4>
            <Comp_Colonies
                ref={tagrefColony}
                // maxTags={1}
                onColonySelect={handleSelectColony}
                onColonyRemove={handleRemoveColony}
                onColonyChangeTag={handleChangeColony}
            >

            </Comp_Colonies>

            <button onClick={handleSetColonyTags}>set Tags</button>
            <button onClick={handleGetColonyTags}>get Tags</button>

      </div>

      <div>
        <h4>General Features</h4>
            <Comp_GeneralFeatures
                ref={tagrefFeature}
                // maxTags={1}
                onGeneralFeatureSelect={handleSelectFeature}
                onGeneralFeatureRemove={handleRemoveFeature}
                onGeneralFeatureChangeTag={handleChangeFeature}
            >

            </Comp_GeneralFeatures>
            <button onClick={handleSetFeatureTags}>set Tags</button>
            <button onClick={handleGetFeatureTags}>get Tags</button>
      </div>

      <div>
        <h4>User Type</h4>
            <Comp_UserTypes
                ref={tagrefUser}
                // maxTags={1}
              //   defaultTags={[ {
              //     "id": 1,
              //     "usertype": "Owner"
              // },
              // {
              //     "id": 2,
              //     "usertype": "Builder"
              // }]}
                onUserTypeSelect={handleSelectUserType}
                onUserTypeRemove={handleRemoveUserType}
                onUserTypeChangeTag={handleChangeUserType}
            >

            </Comp_UserTypes>
            <button onClick={handleSetUserTags}>set Tags</button>
            <button onClick={handleGetUserTags}>get Tags</button>
            <button onClick={handlegetIDTags}>get Tags</button>


      </div>




      <div>
        <h4>Client Type</h4>
            <Comp_ClientTypes
                ref={tagrefClient}
                // maxTags={1}
              //   defaultTags={[ {
              //     "id": 1,
              //     "usertype": "Owner"
              // },
              // {
              //     "id": 2,
              //     "usertype": "Builder"
              // }]}
                onClientTypeSelect={handleSelectClientType}
                onClientTypeRemove={handleRemoveClientType}
                onClientTypeChangeTag={handleChangeClientType}
            >

            </Comp_ClientTypes>
            <button onClick={handleSetClientTags}>set Tags</button>
            <button onClick={handleGetClientTags}>get Tags</button>
            <button onClick={handlegetIDTags}>get Tags</button>


      </div>



      <div>
        <h4>Cities</h4>
            <Comp_Cities
                ref={tagrefCity}
                // maxTags={1}
              //   defaultTags={[ {
              //     "id": 1,
              //     "usertype": "Owner"
              // },
              // {
              //     "id": 2,
              //     "usertype": "Builder"
              // }]}

              selectedTags={selectedCities}
              setSelectedTags={setSelectedCities}
                onCitySelect={handleSelectCity}
                onCityRemove={handleRemoveCity}
                onCityChangeTag={handleChangeCity}
            >

            </Comp_Cities>
            <button onClick={handleSetCityTags}>set Tags</button>
            <button onClick={handleGetCityTags}>get Tags</button>
            {/* <button onClick={handlegetIDTags}>get Tags</button> */}


      </div>





      <div>
        <h4>Developer</h4>
            <Comp_ProjectDeveloper
                ref={tagrefDeveloper}

              selectedTags={selectedDevelopers}
              setSelectedTags={setSelectedDevelopers}
                // onDeveloperSelect={handleSelectDeveloper}
                // onDeveloperRemove={handleRemoveDeveloper}
                // onDeveloperChangeTag={handleChangeDeveloper}
            >

            </Comp_ProjectDeveloper>


      </div>





    </>
  )

}

export default Testpage